import { createSelector } from '@reduxjs/toolkit';

export const getPropertyExclusiveOffersPage = (state) => state?.propertyExclusiveOffersPage?.propertyExclusiveOffersPage || [];
export const getCvp = createSelector(
  getPropertyExclusiveOffersPage,
  (propertyExclusiveOffersPage) => propertyExclusiveOffersPage.valuePropositions,
);
